export default {
  component: () => import('./page.vue'),
  path: '/phone',
  name: 'phone',
  meta: {
    title: '绑定手机',
    auth: true,
  },
};
